function getUserAgent() {
  return navigator.userAgent || navigator.vendor || window.opera;
}

function getOrientation(device) {
  if (device !== 'desktop') {
    return window.innerHeight > window.innerWidth
      ? 'portrait'
      : 'landscape';
  }
  return null;
}

/**
  * Retrieve user device informations. Needs to be able to access document.
  *
  * @returns {Object} deviceProperties
  * @example
  * const device = getDeviceProperties();
  * // device => {
  * //  device: "desktop", -> string
  * //  isLocalStorageAvailable: true, -> boolean
  * //  isShortDesktop: true, -> boolean
  * //  isTouchscreen: false, -> boolean
  * //  mobileOs: null, -> string or null
  * //  orientation: null, -> string or null
  * //  viewport: {width: 1680, height: 452}, -> object
  * // }
*/
function getDeviceProperties() {
  let viewport = {};
  let device = '';
  let isTouchscreen = false;
  let isLocalStorageAvailable = false;
  let mobileOs = null;
  let isShortDesktop = false;

  try {
    viewport = {
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,
    };

    const userAgent = getUserAgent();
    const mobileCheck = {
      ios: userAgent.match(/iPhone|iPad|iPod/i),
      android: userAgent.match(/Android/i),
      tablet: userAgent.match(/ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|KFAPWI/i),
    };

    isTouchscreen = ('ontouchstart' in window || navigator.msMaxTouchPoints > 0) && viewport.width < 951;
    isLocalStorageAvailable = !!window.localStorage;

    if (mobileCheck.ios || mobileCheck.android) {
      mobileOs = mobileCheck.ios ? 'ios' : 'android';
    }

    if ((mobileOs && !mobileCheck.tablet) || viewport.width < 768) {
      device = 'smartphone';
    } else if ((mobileOs && mobileCheck.tablet) || viewport.width < 1024) {
      device = 'tablet';
    } else {
      device = 'desktop';
      if (viewport.height < 651) {
        isShortDesktop = true;
      }
    }
  } catch (error) {
    throw new Error('Failed to look for user device informations.');
  }

  document.documentElement.style.setProperty(
    '--window-inner-height',
    `${window.innerHeight}px`,
  );

  return {
    viewport,
    device,
    isTouchscreen,
    isLocalStorageAvailable,
    mobileOs,
    orientation: getOrientation(device),
    isShortDesktop,
  };
}

export default getDeviceProperties;
